<template>
  <div
    @mouseover="resetPlay()"
    @mouseleave="play()"
  >
    <swiper
      ref="swiper"
      class="swiper"
      :options="swiperOptions"
      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
    >
      <swiper-slide
        v-for="(data,index) in swiperData"
        :key="`${index}-asesor-${data.id}`"
      >
        <perfilProfesor
          :perfil-promo-profesor="data"
        />

      </swiper-slide>
    </swiper>
    <!-- Add Arrows -->
    <b-container>
      <b-row class="m-4">
        <b-col class="text-right d-none d-lg-block">
          <b-button
            size="sm"
            variant="outline-primary"
            pill
            @click="anterior()"
          >
            <feather-icon
              icon="ArrowLeftIcon"
              size="12"
            />
            <small class="ml-2 align-middle">Anterior</small>
          </b-button>
        </b-col>
        <b-col class="text-center">
          <b-pagination-nav
            v-model="currentPage"
            :link-gen="linkGen"
            pills
            size="sm"
            :number-of-pages="numberOfPages"
            base-url="#"
            align="center"
            @page-click="onPageClick"
          />
        </b-col>
        <b-col class="text-left d-none d-lg-block">
          <b-button
            size="sm"
            variant="outline-primary"
            pill
            @click="siguiente()"
          >
            <small class="mr-2 align-middle">Siguiente</small>
            <feather-icon
              icon="ArrowRightIcon"
              size="12"
            />
          </b-button></b-col>
      </b-row>
    </b-container>

  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import {
  BButton, BPaginationNav, BRow, BCol, BContainer,
} from 'bootstrap-vue'
import {
  ref, onMounted, getCurrentInstance, computed, onBeforeUnmount,
} from '@vue/composition-api'
import perfilProfesor from './perfil-profesor.vue'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'swiper/swiper.min.css'

export default {
  components: {
    Swiper,
    SwiperSlide,
    BButton,
    BPaginationNav,
    BRow,
    BCol,
    BContainer,
    perfilProfesor,
  },
  props: {
    swiperData: {
      type: [Array, null],
      default: null,
    },
    hover: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'default',
    },
    acordion: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const vm = getCurrentInstance().proxy
    const swiperOptions = ref({
      slidesPerView: 3,
      slidesPerColumn: 1,
      spaceBetween: 20,
      breakpoints: {
        1024: {
          slidesPerView: 3,
        },
        768: {
          slidesPerView: 3,
        },
        640: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        340: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
      },
    })
    const currentPage = ref(1)
    const numberOfPages = ref(1)
    const numeroElementos = computed(() => props.swiperData?.length)
    const linkGen = () => ''
    let timer
    const onPageClick = (event, page) => {
      vm.$refs.swiper.swiperInstance.slideTo(page - 1, 1000, false)
      currentPage.value = page
    }
    const resetPlay = () => {
      clearInterval(timer)
      timer = null
    }

    const siguiente = () => {
      vm.$refs.swiper.swiperInstance.slideNext()
      if (currentPage.value < numberOfPages.value) currentPage.value += 1
      else {
        currentPage.value = 1
        vm.$refs.swiper.swiperInstance.slideTo(0, 1000, false)
      }
    }

    const play = () => {
      timer = setInterval(() => {
        siguiente()
      }, 2000)
    }

    const anterior = () => {
      vm.$refs.swiper.swiperInstance.slidePrev()
      if (currentPage.value > 1) currentPage.value -= 1
    }
    const setNumeroPaginas = () => {
      const bpsw = vm.$refs.swiper.swiperInstance?.currentBreakpoint
      const slidesPerView = swiperOptions.value.breakpoints[bpsw] ? swiperOptions.value.breakpoints[bpsw].slidesPerView : 1
      numberOfPages.value = (numeroElementos.value / slidesPerView) > 1 ? (numeroElementos.value - (slidesPerView - 1)) : 1
    }
    const handleResize = () => {
      setNumeroPaginas()
    }
    onMounted(() => {
      vm.$refs.swiper.swiperInstance.slideTo(0, 1000, false)
      window.addEventListener('resize', handleResize)
      setNumeroPaginas()
      play()
    })
    onBeforeUnmount(() => {
      window.removeEventListener('resize', handleResize)
      resetPlay()
    })

    return {
      swiperOptions,
      currentPage,
      numberOfPages,
      linkGen,
      onPageClick,
      siguiente,
      anterior,
      resetPlay,
      play,
    }
  },
}
</script>
<style>
 .swiper-slide {
     height: auto;
    }
</style>
